"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageFallback = exports.ImageFallback = void 0;
const app_1 = require("app");
class ImageFallback extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = 'header img, main img, footer img';
    }
    OnInit() {
        this.el.forEach(img => {
            img.addEventListener('error', () => {
                img.parentElement.parentElement.classList.add('img-empty-wrapper', 'bg-surface-disabled');
                img['src'] = '/static/icons/image-broken.svg';
                img.classList.add('img-error', 'lazyloaded', 'fill-icon-disabled');
                img.style.filter =
                    'brightness(0) saturate(100%) invert(99%) sepia(1%) saturate(5645%) hue-rotate(182deg) brightness(83%) contrast(97%)';
                img.style.padding = '10%';
                img.style.objectFit = 'contain';
            });
        });
    }
}
exports.ImageFallback = ImageFallback;
exports.imageFallback = new ImageFallback();
